import { z } from 'zod';
import { goDurationSchema, isValidGoDuration } from '../general/go-duration.ts';

export const punchyRespondDelaySchema = goDurationSchema;

export const punchyRespondDelayRequiredSchema = goDurationSchema.refine(
  (val): val is string => val !== null && val !== '',
  { message: 'Please enter a duration, such as 100ms or 3s' }
);

export const punchyRespondDelayStrictSchema = z.custom<string>(
  (val) => typeof val === 'string' && isValidGoDuration(val)
);
